import axios from 'axios';
import { getMcpBaseUrl } from '../hooks/apiUrlResolver';

export interface McpToolParameter {
  name: string;
  type: string;
  title: string;
  description: string;
  properties?: McpToolParameter[];
}

export interface McpTool {
  name: string;
  description: string;
  use_case: string;
  parameters: McpToolParameter[];
}

export interface McpToolCategory {
  category: string;
  id: string;
  tools: McpTool[];
}

export const fetchRawMcpTools = async (): Promise<McpTool[]> => {
  const { data } = await axios.get<McpTool[]>(`${getMcpBaseUrl()}/tools`);
  return data;
};
